export default "__VITE_ASSET__VE_LHJmw__"